import { FC } from "react";
import { Box, Typography } from "@mui/material";
import React from "react";
const NoData: FC<{ cstmMsg?: string }> = ({ cstmMsg }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
      height="100%"
    >
      <Typography variant="body1">
        {" "}
        {cstmMsg ? cstmMsg : "No Data Found"}{" "}
      </Typography>
    </Box>
  );
};

export default NoData;
